// Dashboard screen map, CP label configuration
const contractPartnerLabelConfig = {
    labelPlacement: 'center-left',
    expression: '$feature.name',
};

export default contractPartnerLabelConfig;
